var render = function render(){var _vm=this,_c=_vm._self._c;return _c('action-list',{staticClass:"insight-actions",attrs:{"items":_vm.menuItems},on:{"action-clicked":function($event){return _vm.$emit('action-clicked', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }